/*
 * // Created on 2024-02-26
 * // Created by Vitaut Tryputsin
 * //
 * // Copyright (c) 2024 OPEN CASCADE SAS
 * //
 * // This file is part of commercial software by OPEN CASCADE SAS,
 * // furnished in accordance with the terms and conditions of the contract
 * // and with the inclusion of this copyright notice.
 * // This file or any part thereof may not be provided or otherwise
 * // made available to any third party.
 * //
 * // No ownership title to the software is transferred hereby.
 * //
 * // OPEN CASCADE SAS makes no representation or warranties with respect to the
 * // performance of this software, and specifically disclaims any responsibility
 * // for any damages, special or consequential, connected with its use.
 *
 */
import { InteractiveObject } from "../interactive-object.js";
/**
 * Represents interactive 3D plane.
 */
export class InteractivePlane extends InteractiveObject {
    /**
     * Constructor.
     * @param theViewer - viewer instance.
     * @param theObjId - object identifier.
     * @param theController - interactive plane controller.
     */
    constructor(theViewer, theObjId = "") {
        super(theViewer, theObjId);
        this._myController = theViewer.interactivePlaneController;
        this._myController.createPlane(this._myObjId);
    }
    /**
     * Clone interactive plane.
     */
    clone() { return new InteractivePlane(this._myViewer, super._clone()); }
    /**
     * Return plane objects.
     */
    get objects() { return this._myController.getObjects(this._myObjId); }
    /**
     * Set plane position.
     */
    set objects(theObjects) { this._myController.setObjects(this._myObjId, theObjects); }
    /**
     * Return plane normal.
     * @returns plane normal.
     */
    get normal() { return this._myController.getPlaneNormal(this._myObjId); }
    /**
     * Set plane normal.
     * @param theNormal - plane normal.
     */
    set normal(theNormal) {
        this._myController.setPlaneNormal(this._myObjId, theNormal);
    }
    /**
     * Return plane location.
     * @returns plane location.
     */
    get location() { return this._myController.getPlaneLocation(this._myObjId); }
    /**
     * Set plane location.
     * @param theLocation - plane location.
     */
    set location(theLocation) {
        this._myController.setPlaneLocation(this._myObjId, theLocation);
    }
}
